import getHelper from '../../../services/getHelper';

export default getHelper('/video-conference-connection/check');
